// extracted by mini-css-extract-plugin
export default {"review-order__list":"review-order__list--XKrkv","reviewOrderList":"review-order__list--XKrkv"};